export class LayoutStateModel {
    public theme: string;
}
